import axios from "axios";
import { useState } from "react";
import Timer from "../../../components/Timer";
import "react-dropdown/style.css";
import DoubleComfirmModal from "../../../components/DoubleConfirmModal/DoubleConfirm";
import { buttonText } from "../../../utils/buttonText";

function DeleteRedundantPage(props) {
  const { item, loadDatasetList } = props;
  const sampleCount = item.samples?.length || 0;

  const [uniquenessThred, setUniquenessThred] = useState(0.2);
  const [computeLoading, setComputeLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [DoubleCheckModalShow, setDoubleCheckModalShow] = useState(false);

  const handleChangeUniquenessThred = (e) => {
    const value = parseFloat(e.target.value);
    setUniquenessThred(isNaN(value) ? 0 : parseFloat(value.toFixed(2)));
  };

  const handleClick = () => {
    setDoubleCheckModalShow(true);
  };

  const computeUniqueness = async () => {
    if (sampleCount === 0) {
      window.alert(`There is no sample in dataset '${item.name}'`);
      return;
    }
    setComputeLoading(true);
    axios
      .get(`/datasets/compute_uniqueness?dataset_name=${item.name}`)
      .then((response) => {
        setComputeLoading(false);
        loadDatasetList();
        window.alert(`Compute uniqueness on dataset '${item.name}' success`);
      })
      .catch((error) => {
        setComputeLoading(false);
        let errorMsg = error.response.data;
        window.alert(errorMsg);
      });
  };

  const deleteRedundantSample = async () => {
    if (uniquenessThred < 0 || uniquenessThred > 1) {
      window.alert(
        `Uniqueness threshold is Invalid. Please choose a number between 0.0 to 1.0`
      );
      return;
    } else if (sampleCount === 0) {
      window.alert(`There is no sample in dataset '${item.name}'`);
      return;
    }
    setDeleteLoading(true);
    let url = `/datasets/delete/redundant_samples?dataset_name=${item.name}&uniqueness_threshold=${uniquenessThred}`;
    axios
      .delete(url)
      .then((response) => {
        setDeleteLoading(false);
        loadDatasetList();
        window.alert(
          `Delete redundant samples on dataset '${item.name}' success`
        );
      })
      .catch((error) => {
        setDeleteLoading(false);
        let errorMsg = error.response.data;
        window.alert(errorMsg);
      });
  };

  return (
    <div className="delete-redundant-page">
      <div className="info-section">
        <p className="card-text">
          Media type: {item.media_type || "unknown"}
        </p>
        <p className="card-text">Samples: {sampleCount.toLocaleString()}</p>
      </div>
      {item.brain_runs_list && item.brain_runs_list.includes("uniqueness") ? (
        <div className="delete-redundant-content">
          <label htmlFor="uniqueness-threshold">Uniqueness Threshold</label>
          <input
            id="uniqueness-threshold"
            type="number"
            min={0}
            max={1}
            step={0.1}
            value={uniquenessThred}
            onChange={handleChangeUniquenessThred}
          />
          <div className="down-button">
            <button
              type="button"
              className="org-btn org-btn-danger"
              onClick={handleClick}
              disabled={deleteLoading}
            >
              {buttonText(deleteLoading ? "Loading..." : "Delete Redundancies")}
            </button>
            <DoubleComfirmModal
              show={DoubleCheckModalShow}
              onHide={() => setDoubleCheckModalShow(false)}
              datasetName={item.name}
              onDelete={deleteRedundantSample}
              title="Delete Redundant"
              text="Data cannot be recovered after deletion, please proceed with caution."
            />
          </div>
        </div>
      ) : (
        <div>
          <div className="top-button">
            <button
              type="button"
              className="org-btn org-btn-primary"
              onClick={computeUniqueness}
              disabled={computeLoading}
            >
              {buttonText(computeLoading ? (
                <span>
                  <Timer loadingStates={[computeLoading]} />
                </span>
              ) : (
                "Compute Uniqueness"
              ))}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DeleteRedundantPage;
